import { render } from "./FeaturesPage.vue?vue&type=template&id=5fe8fbbc&ts=true"
import script from "./FeaturesPage.vue?vue&type=script&lang=ts"
export * from "./FeaturesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__